import React from 'react';
import classNames from 'classnames';

export default function NavHamburger(props) {
  const { onClick } = props;
  const hamClass = classNames(
    'navHamburger',
    { 'navHamburger_hidden': !props.isVisible }
  );

  return (
    <button className={hamClass} onClick={onClick}>
      <span className="isVisuallyHidden">Toggle Menu</span>
      <div className="navHamburger-bar"></div>
      <div className="navHamburger-bar"></div>
      <div className="navHamburger-bar"></div>
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/client/components/nav/nav-hamburger.jsx